import angular from 'angular';
import debounce from 'lodash/debounce';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'pointHistoryTableController',
    ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
      // init variables
      $scope.pointHistoryEnableTableActionMenu = false;
      $scope.pointHistoryInitialLoad = true;
      $scope.pointHistoryIsPageOptions = false;
      $scope.pointHistoryIsSortOptions = false;
      $scope.pointHistoryIsTableActionMenu = false;
      $scope.pointHistoryPageData = {};
      $scope.pointHistoryRecords = [];
      $scope.pointHistoryShowMoreStatus = {};
      $scope.pointHistoryTableLoading = false;

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.generateUserRoute = () => {
        return `${$rootScope.routes.user}/${$scope.user.id}`;
      };

      $scope.rescanConfirmation = false;

      $scope.rescanPointHistory = () => {
        $scope
          .rescanPoints($http, ENV, $rootScope.userId)
          .then(() => {})
          .catch((error) => {});
      };

      $scope.rescanPointHistoryDialogOptions = {
        heading: 'Re-Scan Point History?',
        message: 'This will take some time. Please wait several minutes and then refresh the page.',
        buttons: [
          {
            label: 'OK',
            href: '#',
            clickFn: () => {
              $scope.rescanPointHistory();
              $scope.rescanConfirmation = false;
            },
          },
          {
            label: 'Cancel',
            href: '#',
            clickFn: () => {
              $scope.rescanConfirmation = false;
            },
          },
        ],
      };

      $scope.pointHistoryCheckTableActionsDisplay = () => {
        $scope.pointHistoryEnableTableActionMenu = false;
        angular.forEach($scope.pointHistoryTable.actions, (action) => {
          if (!action.superuser || (action.superuser && $rootScope.isSuperUser)) {
            $scope.pointHistoryEnableTableActionMenu = true;
          }
        });
      };

      $scope.pointHistoryCheckRangeErrors = async (
        filter_key,
        choice_key,
        date_field,
        submission,
      ) => {
        if (!$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          if (submission) {
            if (
              !$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              $scope.pointHistoryTable.filters[key].options.choices[choice_key].error = true;
              return true;
            }
          } else {
            if (
              !$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              return true;
            }
          }
          if (date_field) {
            var from = moment(
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from,
            ).valueOf();
            var to = moment(
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to,
            ).valueOf();
          } else {
            var from =
              $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from;
            var to = $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to;
          }
          if (to - from < 0) {
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].error = true;
            return true;
          }
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].error = false;
          return false;
        }
      };

      $scope.point_history_watch_timeframe_range = async (filter_key, choice_key, target) => {
        if (!$scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          const timeframe = await $scope.format_timeframe_range(
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from,
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to,
          );
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from =
            timeframe[0];
          $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to =
            timeframe[1];
          if (
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key][target] &&
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key][target] !== ''
          ) {
            await angular.forEach(
              $scope.pointHistoryTable.filters[filter_key].options.choices,
              async (choice, key) => {
                if (key == choice_key) {
                  $scope.pointHistoryTable.filters[filter_key].options.choices[key].state = true;
                } else {
                  $scope.pointHistoryTable.filters[filter_key].options.choices[key].state = false;
                }
              },
            );
          }
        }
      };
      angular.forEach($scope.pointHistoryTable.filters, async (filter, filter_key) => {
        angular.forEach(filter.options.choices, async (choice, choice_key) => {
          if ('from' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
              async () => {
                if (choice.date_field) {
                  await $scope.point_history_watch_timeframe_range(filter_key, choice_key, 'from');
                }
                var areErrors = await $scope.pointHistoryCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
          if ('to' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
              async () => {
                if (choice.date_field) {
                  await $scope.point_history_watch_timeframe_range(filter_key, choice_key, 'to');
                }
                var areErrors = await $scope.pointHistoryCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
        });
      });

      // Angucomplete Filter

      $scope.pointHistoryFilterAngucomplete = (query, key) => {
        return $scope
          .angucompleteSearch(
            $http,
            ENV,
            $scope.pointHistoryTable.filters[key].options.search_endpoint,
            $scope.pointHistoryTable.filters[key].options.search_endpoint_data_key,
            { search: query, autocomplete: true },
          )
          .then((res) => res);
      };

      $scope.pointHistoryFilterAngucompletePage = (query, key) => {
        return $scope
          .angucompleteSearchByUrl(
            $http,
            query,
            $scope.pointHistoryTable.filters[key].options.search_endpoint_data_key,
          )
          .then((res) => res);
      };

      $scope.pointHistorySetSelectedAngucomplete = (item, key) => {
        $scope.pointHistoryTable.filters[key].options.selected.push(item);
      };

      $scope.pointHistoryRemoveAngucomplete = (id, key) => {
        $scope.pointHistoryTable.filters[key].options.selected = $scope.pointHistoryTable.filters[
          key
        ].options.selected.filter((item) => item.id !== id);
      };

      $scope.pointHistoryRemoveAllAngucomplete = (key) => {
        $scope.pointHistoryTable.filters[key].options.selected = [];
      };

      $scope.point_history_change_timeframe = async (new_timeframe_choice) => {
        await angular.forEach($scope.pointHistoryTable.filters, async (filter, filter_key) => {
          if (filter.options.query_string_parameter == 'timeframe') {
            await angular.forEach(filter.options.choices, async (choice, choice_key) => {
              if (choice.value == new_timeframe_choice) {
                $scope.pointHistoryTable.filters[filter_key].options.choices[
                  choice_key
                ].state = true;
              } else {
                $scope.pointHistoryTable.filters[filter_key].options.choices[
                  choice_key
                ].state = false;
              }
            });
          }
        });
      };

      // Get Table Data

      $rootScope.getPointHistory = async () => {
        $scope.pointHistoryTableLoading = true;
        var parameters = {};
        $scope.pointHistoryPageData = {};
        $scope.pointHistoryRecords = [];
        await angular.forEach($scope.pointHistoryTable.filters, async (filter, key) => {
          if (filter.type == 'multiple_choice') {
            parameters[filter.options.query_string_parameter] = Object.values(
              filter.options.choices,
            )
              .filter((item) => item.state === true)
              .map((item) => item.value)
              .join(',');
            if (
              (!(filter.options.query_string_parameter in parameters) ||
                parameters[filter.options.query_string_parameter] == '') &&
              'no_selected_parameter' in filter.options
            ) {
              parameters[filter.options.query_string_parameter] =
                filter.options.no_selected_parameter;
            }
          }
          if (filter.type == 'multi_level_multiple_choice') {
            var multi_level_selected = [];
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (choice.state === true) {
                if ('options' in choice) {
                  var options = '';
                  await angular.forEach(choice.options, async (level, level_key) => {
                    if (level.state) {
                      options = options + `:${level.value}`;
                    }
                  });
                  if (options !== '') {
                    multi_level_selected.push(`${choice.value}${options}`);
                  }
                }
              }
            });
            if (multi_level_selected.length) {
              parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
            }
          }
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if ('error' in $scope.pointHistoryTable.filters[key].options.choices[choice_key]) {
                $scope.pointHistoryTable.filters[key].options.choices[choice_key].error = false;
              }
              if (choice.state === true) {
                if (choice.type == 'standard') {
                  parameters[filter.options.query_string_parameter] = choice.value;
                } else if (choice.type == 'amount') {
                  if (!choice.amount || choice.amount == '') {
                    $scope.pointHistoryTable.filters[key].options.choices[choice_key].error = true;
                  } else {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.amount}`;
                  }
                } else if (choice.type == 'range') {
                  if (choice.date_field) {
                    const formatted_dates = await $scope.format_timeframe_range(
                      choice.from,
                      choice.to,
                    );
                    var date_from = null;
                    var date_to = null;
                    if (formatted_dates[0] && formatted_dates[0] != '') {
                      var date = moment(formatted_dates[0]);
                      date_from = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[0];
                      $scope.pointHistoryTable.filters[key].options.choices[
                        choice_key
                      ].from = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (formatted_dates[1] && formatted_dates[1] != '') {
                      var date = moment(formatted_dates[1]);
                      date_to = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[1];
                      $scope.pointHistoryTable.filters[key].options.choices[
                        choice_key
                      ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (
                      $scope.pointHistoryTable.filters[key].options.choices[choice_key].from &&
                      $scope.pointHistoryTable.filters[key].options.choices[choice_key].to
                    ) {
                      var areErrors = await $scope.pointHistoryCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `range:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.pointHistoryTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  } else {
                    if (choice.to && choice.from) {
                      var areErrors = await $scope.pointHistoryCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `${choice.value}:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.pointHistoryTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  }
                }
              }
            });
          }
          if (filter.type == 'angucomplete' && 'search_endpoint' in filter.options) {
            if (filter.options.selected.length) {
              parameters[filter.options.query_string_parameter] = filter.options.selected
                .map((item) => item.id)
                .join(',');
            }
          }
        });

        var error = false;
        await angular.forEach($scope.pointHistoryTable.filters, async (filter, key) => {
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (
                'error' in $scope.pointHistoryTable.filters[key].options.choices[choice_key] &&
                $scope.pointHistoryTable.filters[key].options.choices[choice_key].error
              ) {
                error = true;
              }
            });
          }
        });
        if (error) {
          return;
        }

        const sortOptions = [];
        await Object.entries($scope.pointHistoryTable.sort_options).forEach(([key, item]) => {
          if (item.state === true) {
            sortOptions.push(item.value === '1' ? key : `-${key}`);
          }
        });
        parameters['order'] = sortOptions.join(',');
        parameters['page_size'] = $scope.pointHistoryTable.options.records_per_page;
        $scope
          .getTableData(
            $http,
            ENV,
            $scope.pointHistoryTable.options.endpoint,
            $scope.pointHistoryTable.options.endpoint_data_key,
            parameters,
          )
          .then((res) => {
            $timeout(async () => {
              if ($scope.pointHistoryTable.options.scale_up) {
                if (
                  res.meta.count === 0 &&
                  'timeframe' in parameters &&
                  parameters.timeframe != 'all' &&
                  $scope.pointHistoryInitialLoad
                ) {
                  switch (parameters.timeframe) {
                    case 'day':
                      await $scope.point_history_change_timeframe('week');
                      break;
                    case 'week':
                      await $scope.point_history_change_timeframe('year');
                      break;
                    case 'year':
                      await $scope.point_history_change_timeframe('all');
                      break;
                  }
                  return $rootScope.getPointHistory();
                }
              }
              $scope.pointHistoryTableLoading = false;
              $scope.pointHistoryPageData = res;
              $scope.pointHistoryInitialLoad = false;
              $scope.pointHistoryShowMoreStatus = {};
              $scope.pointHistoryScrollToTop();
            });
          });
      };

      $scope.goTopointHistoryPage = (url) => {
        $scope.pointHistoryTableLoading = true;
        $scope.pointHistoryPageData = {};
        $scope.pointHistoryRecords = [];
        $scope
          .getTableDataByUrl($http, url, $scope.pointHistoryTable.options.endpoint_data_key)
          .then((res) => {
            $timeout(() => {
              $scope.pointHistoryPageData = res;
              $scope.pointHistoryTableLoading = false;
              $scope.pointHistoryScrollToTop();
            });
          });
      };

      $scope.pointHistoryValidCustomValue = (filter_key, choice_key, key) => {
        if (key === 'amount') {
          $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].amount = $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].amount.replace(/[^0-9\-]+/g, '');
          if (
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].amount ===
              '' ||
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].amount === null
          ) {
            return;
          }
        }
        if (key === 'range') {
          $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].from = $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].from.replace(/[^0-9\-]+/g, '');
          $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].to = $scope.pointHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].to.replace(/[^0-9\-]+/g, '');
          if (
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from ===
              null ||
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].from === '' ||
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to === null ||
            $scope.pointHistoryTable.filters[filter_key].options.choices[choice_key].to === ''
          ) {
            return;
          }
        }
      };

      $scope.pointHistoryClearText = async (filter_key, choice_key) => {
        await angular.forEach(
          $scope.pointHistoryTable.filters[filter_key].options.choices,
          async (choice, key) => {
            if (key == choice_key) {
              $scope.pointHistoryTable.filters[filter_key].options.choices[key].state = true;
            } else {
              $scope.pointHistoryTable.filters[filter_key].options.choices[key].state = false;
              if ('error' in choice) {
                $scope.pointHistoryTable.filters[filter_key].options.choices[key].error = false;
              }
              if ('amount' in choice) {
                $scope.pointHistoryTable.filters[filter_key].options.choices[key].amount = '';
              }
              if ('from' in choice || 'to' in choice) {
                $scope.pointHistoryCheckRangeErrors(
                  filter_key,
                  key,
                  $scope.pointHistoryTable.filters[filter_key].options.choices[key].date_field,
                  false,
                );
              }
            }
          },
        );
      };

      $scope.pointHistorySwitchSelectAll = (key, value) => {
        Object.values($scope.pointHistoryTable.filters[key].options.choices).forEach((item) => {
          item.state = value;
          if ('options' in item) {
            Object.values(item.options).forEach((option) => {
              option.state = value;
            });
          }
        });
      };

      $scope.pointHistoryShowPageOptions = () => {
        $scope.pointHistoryIsPageOptions = !$scope.pointHistoryIsPageOptions;
      };

      $scope.showPointHistoryActionMenu = () => {
        $scope.isPointHistoryActionMenu = !$scope.isPointHistoryActionMenu;
      };

      $scope.pointHistorySelectPageOption = (option) => {
        $scope.pointHistoryTable.options.records_per_page = option;
      };

      $scope.pointHistoryShowSortOptions = () => {
        $scope.pointHistoryIsSortOptions = !$scope.pointHistoryIsSortOptions;
      };

      $scope.pointHistorySelectSort = async (option_key, value) => {
        await angular.forEach($scope.pointHistoryTable.sort_options, async (option, key) => {
          if (key == option_key) {
            $scope.pointHistoryTable.sort_options[key].value = value;
            $scope.pointHistoryTable.sort_options[key].state = true;
          }
        });
      };

      $scope.pointHistorySelectSortOptions = () => {
        $scope.pointHistoryIsSortOptions = false;
      };

      $scope.pointHistoryShowSortTitles = () => {
        return Object.values($scope.pointHistoryTable.sort_options)
          .filter((item) => item.state === true)
          .map((item) => item.title)
          .join(', ');
      };

      $scope.pointHistoryGetChoices = async () => {
        await Promise.all(
          $scope.pointHistoryTable.filters.map(async (value, key) => {
            if (
              (value.type == 'multiple_choice' || value.type == 'multi_level_multiple_choice') &&
              'choices_endpoint' in value.options
            ) {
              const choices = await $scope.getTableFilterOptions(
                $http,
                ENV,
                value.options.choices_endpoint,
                value.options.choices_endpoint_data_key,
              );
              if (choices && !!choices.length) {
                await choices.forEach((item) => {
                  var state =
                    ('default_choice' in value.options &&
                      item[value.options.name_attribute] == value.options.default_choice) ||
                    !('default_choice' in value.options)
                      ? true
                      : false;
                  $scope.pointHistoryTable.filters[key].options.choices[
                    item[value.options.name_attribute]
                  ] = {
                    state: state,
                    value: item.id,
                  };
                  if ('level' in value.options && value.options.level) {
                    $scope.pointHistoryTable.filters[key].options.choices[
                      item[value.options.name_attribute]
                    ]['options'] = angular.copy(value.options.level);
                  }
                });
              }
            }
          }),
        );
        $rootScope.getPointHistory();
      };

      $scope.pointHistoryGetRedemptionDetail = (index, redemption_id) => {
        $scope
          .getTableData($http, ENV, `/2.0/redemptions/${redemption_id}/`, 'redemptions', {})
          .then((res) => {
            $timeout(async () => {
              $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][
                index
              ].redemption = res['redemptions'];
              $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][
                index
              ].redemption.reward = res['redemptions'].reward.description;
            });
          });
      };

      $scope.pointHistoryGetTransactionDetail = (index, transaction_id) => {
        $scope
          .getTableData($http, ENV, `/2.0/transactions/${transaction_id}/`, 'transactions', {})
          .then((res) => {
            $timeout(async () => {
              $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][
                index
              ].transaction = res['transaction'];
            });
          });
      };

      $scope.pointHistoryShowMore = (index) => {
        $scope.pointHistoryShowMoreStatus[index] = !$scope.pointHistoryShowMoreStatus[index];
        if (
          $scope.pointHistoryTable.options.row_style == 'redemption' &&
          !(
            'redemption' in
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
          )
        ) {
          $scope.pointHistoryGetRedemptionDetail(
            index,
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
              .id,
          );
        } else if (
          $scope.pointHistoryTable.options.row_style == 'activity' &&
          !(
            'redemption' in
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
          ) &&
          !(
            'transaction' in
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
          )
        ) {
          if (
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index][
              'activity_type'
            ].includes('Redemption')
          ) {
            $scope.pointHistoryGetRedemptionDetail(
              index,
              $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
                .redemption_id,
            );
          } else if (
            $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index][
              'activity_type'
            ].includes('Transaction')
          ) {
            $scope.pointHistoryGetTransactionDetail(
              index,
              $scope.pointHistoryPageData[$scope.pointHistoryTable.options.endpoint_data_key][index]
                .transaction_id,
            );
          }
        }
      };

      $scope.pointHistoryShowTableActionMenu = () => {
        $scope.pointHistoryIsTableActionMenu = !$scope.pointHistoryIsTableActionMenu;
      };

      $scope.pointHistoryScrollToTop = () => {
        $('point-history-table .container').scrollTop(0);
        $('point-history-table .filter-panel').scrollTop(0);
      };

      $(document).on('click', (event) => {
        const pageOptionEle = $('point-history-table .page-content');
        const sortOptionEle = $('point-history-table .sort-content');
        const tableActionsEle = $('point-history-table .table-actions-options');
        const settingEle = $('point-history-table .header-actions');
        var $target = $(event.target);

        if (settingEle !== event.target && !settingEle.has(event.target).length) {
          $scope.$apply(() => {
            $scope.isPointHistoryActionMenu = false;
          });
        }

        if (
          pageOptionEle !== event.target &&
          !$target.closest('point-history-table .page-content').length &&
          !pageOptionEle.has(event.target).length
        ) {
          $timeout(() => {
            $scope.pointHistoryIsPageOptions = false;
          });
        }
        if (
          sortOptionEle !== event.target &&
          !$target.closest('point-history-table .sort-content').length &&
          !sortOptionEle.has(event.target).length &&
          $scope.pointHistoryIsSortOptions
        ) {
          $timeout(() => {
            $scope.pointHistoryIsSortOptions = false;
            $scope.pointHistorySelectSortOptions();
          });
        }
        if (
          tableActionsEle !== event.target &&
          !$target.closest('point-history-table .table-actions-options').length &&
          !tableActionsEle.has(event.target).length &&
          $scope.pointHistoryIsTableActionMenu
        ) {
          $timeout(() => {
            $scope.pointHistoryIsTableActionMenu = false;
          });
        }
      });

      $scope.init();

      const pointHistoryComponentVisibleListener = $rootScope.$watch('componentOpened', () => {
        if (!$rootScope.componentOpened) {
          $scope.pointHistoryEnableTableActionMenu = false;
          $scope.pointHistoryInitialLoad = true;
          $scope.pointHistoryIsPageOptions = false;
          $scope.pointHistoryIsSortOptions = false;
          $scope.pointHistoryIsTableActionMenu = false;
          $scope.pointHistoryPageData = {};
          $scope.pointHistoryRecords = [];
          $scope.pointHistoryShowMoreStatus = {};
          $scope.clearPointHistoryDetail();
        }
      });

      $scope.watcherPointHistoryTrigger = () => {
        $scope.setTable();
        if ($rootScope.isPointDisplay && $rootScope.userId) {
          $scope.pointHistoryEnableTableActionMenu = false;
          $scope.pointHistoryInitialLoad = true;
          $scope.pointHistoryIsPageOptions = false;
          $scope.pointHistoryIsSortOptions = false;
          $scope.pointHistoryIsTableActionMenu = false;
          $scope.pointHistoryPageData = {};
          $scope.pointHistoryRecords = [];
          $scope.pointHistoryShowMoreStatus = {};
          $scope.pointHistoryCheckTableActionsDisplay();
          $scope.pointHistoryGetChoices();
          $scope.pointHistoryScrollToTop();
        } else {
          $scope.pointHistoryEnableTableActionMenu = false;
          $scope.pointHistoryInitialLoad = true;
          $scope.pointHistoryIsPageOptions = false;
          $scope.pointHistoryIsSortOptions = false;
          $scope.pointHistoryIsTableActionMenu = false;
          $scope.pointHistoryPageData = {};
          $scope.pointHistoryRecords = [];
          $scope.pointHistoryShowMoreStatus = {};
          $scope.clearPointHistoryDetail();
        }
      };

      const isPointDisplayListener = $rootScope.$watch('isPointDisplay', () => {
        $scope.watcherPointHistoryTrigger();
      });

      $scope.$on('$destroy', function () {
        $scope.unsubscribe();
        isPointDisplayListener();
        pointHistoryComponentVisibleListener();
      });
    },
  )
  .directive('pointHistoryTable', () => {
    return {
      templateUrl: 'templates/v2/point-history-table.html',
    };
  });
